export default {
  title: "Dojen"
};
